export enum LocalStorageKeys {
  TOKEN = 'TOKEN',
  REFERRER = 'REFERRER',
}
